import { DxScrollViewComponent } from 'devextreme-angular/ui/scroll-view';
import { Note, NoteResponse } from './../../../shared/models/note';
import { Subscription } from 'rxjs';
import { UtilitiesService } from 'src/app/shared/services/utilities.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NotesService } from 'src/app/shared/services/notes.service';

@Component({
  selector: 'app-note-detail',
  templateUrl: './note-detail.component.html',
  styleUrls: ['./note-detail.component.scss']
})
export class NoteDetailComponent implements OnInit {
  public userData;
  public note: Note;
  public noteResponse: NoteResponse;
  public idNote: number;
  public mensaje: string;
  private _subscriptions: Subscription[] = [];

  @ViewChild(DxScrollViewComponent, { static: false }) scrollView: DxScrollViewComponent;

  constructor(
    private utilitiesService: UtilitiesService,
    private notesService: NotesService,
    private router: Router,
    private route: ActivatedRoute
  ) { 
    if (this.route.snapshot.params['id']) {
      this.idNote = this.route.snapshot.params['id'];
      this.noteResponse = new NoteResponse(null);
      
    } else {
      this.router.navigate([`/dash/notes`]);
    }
    this.userData = this.utilitiesService.getUserData();
    console.log(this.userData);
  }

  ngOnInit() {
    this._subscriptions.push(
      this.notesService.getNoteDetail(this.idNote).subscribe( (res: any) => {
        console.log(res);
        if(res.data) {
          this.note = res.data.Note;
          this.note.responses = res.data.NoteResponses;
          console.log(this.note);
          this.scroll();
        }
        
      }, error => {
        console.log(error);
      })
    );
  }
  addResponse() {
    this.noteResponse.idNote = this.note.idNote;
    this.noteResponse.idUser = this.userData.id;
    this.noteResponse.userName = this.userData.name+' '+this.userData.lastName+' '+this.userData.secondLastName;
    this.noteResponse.userEmail = this.userData.email;
    console.log(this.noteResponse);
    this.notesService.addResponse(this.noteResponse).subscribe(res => {
      console.log(res);
      this.utilitiesService.notifyMe('Comentario enviado con éxito', 'success');
      if(this.note.status == 1) {
        this.updateStatus(3);
      }
    }, error => {
      console.log(error);
      this.utilitiesService.notifyMe('No se pudo enviar la respuesta', 'error');
    },() => {
      this.noteResponse = new NoteResponse(null);
      this.updateResponses();
    });
  }

  public updateResponses() {
    this.notesService.getNoteDetail(this.idNote).subscribe( (res: any) => {
      console.log(res);
      if(res.data) {
        this.note = res.data.Note;
        this.note.responses = res.data.NoteResponses;
        console.log(this.note);
      }
    });
  }

  async updateStatus(status) {
    await this.notesService.updateStatus(this.note.idNote, status).toPromise()
    .then((res: any) => {
        console.log(res);
        this.note.status = res.data.status;
        this.note.statusName = res.data.statusName
    }).catch(err => {
      console.log(err);
    });
  }
  scroll() {
    this.scrollView.instance.scrollToElement(document.querySelector('#end'));
}
  ngOnDestroy() {
    this._subscriptions.forEach(s => s.unsubscribe());
  }

}
